import { render, staticRenderFns } from "./VerArticulo.vue?vue&type=template&id=14e75bb0&"
import script from "./VerArticulo.vue?vue&type=script&lang=js&"
export * from "./VerArticulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports